import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

import SiteMetaContext from "../contexts/SiteMetaContext";
import { formatPrice } from "../helpers/propertyHelper";
import { getTranslatedValue } from "../helpers/translationHelper";
import { prepareImageURL } from "../helpers/helper";

import property1 from "../themes/theme1/images/property-image-1.jpg";
import locationIcon from "../images/marker-red.png";

const OpenStreetMapOverlay = ({ listing, listingType, closeInfoWindow }) => {
    const siteData = useContext(SiteMetaContext);
    const {
        remarso: {
            domainByURL: {
                website: {
                    id: website_id,
                    company: { currency: company_currency },
                    setting: {
                        display_watermark
                    }
                },
            },
        },
        currentLocaleKey: locale,
        defaultLocaleKey: defaultLocale,
    } = siteData;

    const { pictures, translations } = listing;
    const image = pictures && pictures.length > 0 ? prepareImageURL(pictures[0], website_id, 320, 240, display_watermark == 2) : property1;
    const headline = getTranslatedValue(translations, "headline", locale, defaultLocale) || '';

    if (listingType == 'property') {
        return (
            <div className="g-info-box">
                <a className="ol-popup-close" onClick={closeInfoWindow}></a>
                <div className="g-info-media">
                    <img src={image} alt="" className="g-info-image"/>
                </div>
                <div className="g-info-body">
                    <div className="g-info-body-top">
                        <span className="g-info-nm" dangerouslySetInnerHTML={{ __html: headline }}></span>
                        <span className="g-info-loc"><img src={locationIcon} alt=""/>{listing.location}</span>
                        <span className="g-info-prc">{formatPrice(listing, company_currency)}</span>
                    </div>
                    <div className="g-info-action">
                        <Link to={`/${locale}/property/${listing.uuid}`} className="view">View</Link>
                    </div>
                </div>
            </div>
        );

    } else {
        return (
            <div className="g-info-box">
                <a className="ol-popup-close" onClick={closeInfoWindow}></a>
                <div className="g-info-media">
                    <img src={image} alt="" className="g-info-image"/>
                </div>
                <div className="g-info-body">
                    <div className="g-info-body-top">
                        <span className="g-info-nm" dangerouslySetInnerHTML={{ __html: headline }}></span>
                        <span className="g-info-loc"><img src={locationIcon} alt=""/>{listing.location}</span>
                        <span className="g-info-prc">{listing.name}</span>
                    </div>
                    <div className="g-info-action">
                        <Link to={`/${locale}/building/${listing.uuid}`} className="view">View</Link>
                    </div>
                </div>
            </div>
        );
    }
};

OpenStreetMapOverlay.propTypes = {
    listing: PropTypes.object.isRequired,
    listingType: PropTypes.string.isRequired,
    closeInfoWindow: PropTypes.func.isRequired
};

export default OpenStreetMapOverlay;
